function Header() {
  return (
    <header className="app-header">
      <img src="vokage-logo.jpg" alt="React logo" />
      <h1>Vokage</h1>
    </header>
  );
}

export default Header;
